import React from "react";

import { SkeletonBlock } from "./primitives/index";

/**
 * Pagination row skeleton (no-user variant) — for tables without avatar columns.
 * Renders a single row with text-only columns, responsive width.
 */
const DataTablePaginationNoUserLoader = () => {
  return (
    <div className="DataTablePaginationLoader mb-4 flex !w-full">
      <div className="skeleton-table-row w-full" style={{ minHeight: 68 }}>
        <SkeletonBlock width="12%" height={14} radius="sm" />
        <SkeletonBlock width="18%" height={14} radius="sm" />
        <SkeletonBlock width="25%" height={14} radius="sm" />
        <SkeletonBlock width="12%" height={14} radius="sm" />
        <SkeletonBlock width="10%" height={14} radius="sm" />
        <SkeletonBlock width="8%" height={14} radius="sm" />
      </div>
    </div>
  );
};

export default DataTablePaginationNoUserLoader;
